export default {"src":"/_next/static/media/compare-icon.efaf3dbb.svg","height":95,"width":88,"blurWidth":0,"blurHeight":0};